import React, { useEffect, useRef } from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {
  useIsAuthenticated,
  useMsal,
} from '@azure/msal-react'
import { Box, Button } from '@mui/material'
import OutputView from './Pages/OutputView';
import ErrorBoundary from './Components/ErrorBoundary';
import { wakeupCall } from './utils';

function App () {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated()
  const didWakeupRun = useRef(false)

  // Wakeup call to backend on app launch
  useEffect(() => {
    if (didWakeupRun.current) return
    didWakeupRun.current = true

    const abortController = new AbortController()

    wakeupCall(abortController.signal).catch(() => {
      // Ignore abort errors
    })

    return () => {
      abortController.abort()
      didWakeupRun.current = false
    }
  }, [])

  return (
    <ErrorBoundary>
      <Box sx={{ textAlign: 'center' }}>
        {
          isAuthenticated && (
            <Router>
              <Routes>
                <Route path="/" element={<OutputView />} />
              </Routes>
            </Router>
          )
        }
        {
          !isAuthenticated && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                height: '100vh',
              }}
            >
              <Button onClick={() => instance.loginPopup()} variant="contained" size="large">Login</Button>
            </Box>
          )
        }
      </Box>
    </ErrorBoundary>
  )
}

export default App
